/**
 * Detects whether the current device is a phone or tablet that
 * cannot reliably run the auction experience (Speech Recognition API,
 * concurrent mic + speaker, etc.).
 *
 * Detection strategy:
 *   1. UA-token check  – catches iPhones, Android phones, Android tablets,
 *      Windows Phone, BlackBerry, and Opera Mini.
 *   2. iPad heuristic  – iPadOS 13+ reports a Mac-desktop UA, so we also
 *      flag any "Macintosh" UA that exposes > 1 touch point (real Macs
 *      report 0–1; iPads report 5).
 *
 * Returns `true` for phones and tablets; `false` for laptops / desktops.
 */

const MOBILE_UA_PATTERN =
  /iPhone|iPod|Android|Windows Phone|BlackBerry|Opera Mini/i;

/**
 * @param {string}  [ua]          – override for testing (defaults to navigator.userAgent)
 * @param {number}  [touchPoints] – override for testing (defaults to navigator.maxTouchPoints)
 * @returns {boolean}
 */
export default function isMobileDevice(
  ua = navigator.userAgent,
  touchPoints = navigator.maxTouchPoints ?? 0,
) {
  // 1. Straightforward phone / Android-tablet / legacy-iPad tokens
  if (MOBILE_UA_PATTERN.test(ua)) return true;

  // 2. iPad running iPadOS 13+ — UA says "Macintosh" but touch is present
  if (/Macintosh/i.test(ua) && touchPoints > 1) return true;

  return false;
}
